import { forwardRef, FunctionComponent, RefObject, SVGProps, useState } from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { Moment } from 'moment';
import { ReactComponent as CalendarSVG } from '../../assets/icons/patientProfileIcons/calendarIcon.svg';
import styles from './index.module.scss';
import classNames from 'classnames';
import { dateValidationError } from './types';
import DateTextField from './DateTextField';

interface CustomDatePickerType extends DatePickerProps<Moment> {
  helperText?: string;
  isError?: boolean;
  addWrapperClass?: boolean;
  useBlackBorder?: boolean;
  labelClassName?: string;
  e2eTestName?: string;
  isRequired?: boolean;
  removeIcon?: boolean;
  CustomIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  validationErrorKey?: dateValidationError;
  inputClassName?: string;
}

const CalendarIcon = (params: { removeIcon?: boolean }, CustomIcon?: FunctionComponent<SVGProps<SVGSVGElement>>) => {
  const { removeIcon } = params;
  const Icon = CustomIcon ?? CalendarSVG;
  return !removeIcon ? <Icon /> : null;
};

export default forwardRef((props: CustomDatePickerType, ref) => {
  const {
    onChange,
    isError,
    isRequired,
    labelClassName,
    e2eTestName,
    helperText,
    addWrapperClass,
    useBlackBorder,
    removeIcon,
    validationErrorKey,
    inputClassName,
    CustomIcon,
    ...datePickerProps
  } = props;
  const [validationError, setValidationError] = useState<string>('');
  return (
    <DatePicker
      ref={ref as RefObject<HTMLInputElement>}
      onChange={onChange}
      onError={(newError) => {
        setValidationError(
          newError === validationErrorKey ? 'Please enter a valid date' : ''
        );
      }}
      slotProps={{
        actionBar: {
          actions: ['clear', 'today'],
        },
        openPickerIcon: {
          removeIcon: removeIcon,
        },
        textField: {
          error: isError,

          onInput: () => setValidationError(''),
          helperText: helperText ?? validationError,
          className: classNames(
            labelClassName,
            isRequired ? styles.root : '',
            addWrapperClass ? styles.rootWrapper : ''
          ),
          inputProps: {
            required:isRequired,
            inputclassname: classNames(
              styles.inputField,
              inputClassName,
              useBlackBorder ? styles.useBlackBorder : '',
              removeIcon ? styles.removeIconStyle : ''
            ),
            datacy: e2eTestName ?? '',
          },
        },
      }}
      {...datePickerProps}
      slots={{ openPickerIcon: (params) => {return CalendarIcon(params, CustomIcon)}, textField: DateTextField }}
    />
  );
});
